import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { FaEye, FaTrash, FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../redux/features/modalSlice";
import Pagination from "../../../common/Pagination";
import {
  getEnquriesList,
  getVendorEnquiriesList,
  DeleteEnquiry,
  VendorDeleteEnquiry,
  ContactUsChangeStatus,
  VendorEnquiryChangeStatus,
} from "../../../redux/services/EnquriesService/enquries.Services";
import { STATUS_OPTIONS } from '../../../Constant/leadConstent';
function EnquiryList() {
  const dispatch = useDispatch();
  const { refreshData } = useSelector((state) => state.modal);

  const [rolesData, setRolesData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [totalRoles, setTotalRoles] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [activeTab, setActiveTab] = useState("website");

  const fetchRoles = async (pageNo = 1, isInitialLoad = false, tab = activeTab) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }

      const payload = { page: pageNo, per_page: limit };

      const apiCall =
        tab === "vendor" ? getVendorEnquiriesList : getEnquriesList;

      const res = await apiCall(payload);

      setRolesData(res?.data || []);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalRoles(res?.total || 0);
    } catch (err) {
      console.log(err);
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchRoles(newPage, false, activeTab);
    }
  };

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    setRolesData([]);
    setPage(1);
    fetchRoles(1, true, tab);
  };

  useEffect(() => {
    fetchRoles(1, true, activeTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData, limit, activeTab]);

  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* HEADER + BUTTONS */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Enquries List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Enquries List</span>
          </nav>
        </div>

        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="add-btn"
            onClick={() => handleTabChange("website")}
            style={
              activeTab !== "website"
                ? {
                  background: "transparent",
                  color: "#6c757d",
                  border: "1px solid #6c757d",
                }
                : {}
            }
          >
            Website Enquiries
          </button>

          <button
            type="button"
            className="add-btn"
            onClick={() => handleTabChange("vendor")}
            style={
              activeTab !== "vendor"
                ? {
                  background: "transparent",
                  color: "#6c757d",
                  border: "1px solid #6c757d",
                }
                : {}
            }
          >
            Vendor Panel Enquiries
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main_page">
        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <div className="col-12 d-flex justify-content-end">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Update Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <div className="spinner-border text-primary"></div>
                    </td>
                  </tr>
                ) : rolesData.length > 0 ? (
                  rolesData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.mobile || item.phone}</td>
                      <td>{item.email}</td>
                      <td>
                        <select
                          className={`form-select form-select-sm kyc-status-select ${item.status === "approved"
                              ? "kyc-approve"
                              : item.status === "rejected"
                                ? "kyc-reject"
                                : "kyc-pending"
                            }`}
                          value={item.status || "pending"}
                          onChange={(e) => {
                            const newStatus = e.target.value;
                            if (newStatus === (item.status || "pending")) return;

                            // ✅ Direct remark modal — no confirmation
                            dispatch(
                              openModal({
                                type: "enduiry-status-remark",
                                title: "Enquiry Status Remark",
                                data: {
                                  id: item.id,
                                  currentStatus: item.status || "pending",
                                  newStatus: newStatus,
                                  refreshRemarks: () => fetchRoles(page),

                                  onSubmit: async (payload) => {
                                    const statusFunction =
                                      activeTab === "vendor"
                                        ? VendorEnquiryChangeStatus
                                        : ContactUsChangeStatus;

                                    return await statusFunction(payload);
                                  },
                                },
                              })
                            );
                          }}
                          style={{ width: "140px", height: "36px", fontSize: "13px", fontWeight: 600 }}
                        >
                          <option value="pending">Pending</option>
                          <option value="approved">Approve</option>
                          <option value="rejected">Reject</option>
                        </select>
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          {/* View Button */}
                          {/* <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: activeTab === "vendor" ? "view-module-enquiry" : "view-enquiry",
                                  title: activeTab === "vendor" ? "View Vendor Enquiry" : "View Enquiry",
                                  data: item,
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button> */}
<button
  className="st-action-btn st-delete-btn"
  onClick={() =>
    dispatch(
      openModal({
        type: "view-enquiry",   // ✅ dono tabs ke liye same
        title: activeTab === "vendor" ? "View Vendor Enquiry" : "View Enquiry",
        data: item,
      })
    )
  }
>
  <FaEye />
</button>
                          {/* ✅ NEW: Status Change Button */}
                          {/* <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: activeTab === "vendor"
                                    ? "change-vendor-enquiry-status"
                                    : "change-enquiry-status",
                                  title: activeTab === "vendor"
                                    ? "Change Vendor Enquiry Status"
                                    : "Change Enquiry Status",
                                  data: {
                                    id: item.id,
                                    name: item.name,
                                    status: item.status,
                                    admin_remark: item.admin_remark,
                                    statusFunction:
                                      activeTab === "vendor"
                                        ? VendorEnquiryChangeStatus
                                        : ContactUsChangeStatus,
                                    refreshData: fetchRoles,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button> */}


                          {/* Edit Button - Add this between View and Status Change */}
                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type: activeTab === "vendor" ? "edit-vendor-enquiry" : "edit-enquiry",
                                  title: activeTab === "vendor" ? "Edit Vendor Enquiry" : "Edit Enquiry",
                                  data: {
                                    ...item,
                                    isVendor: activeTab === "vendor",
                                    refreshData: fetchRoles,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>










                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openModal({
                                  type:
                                    activeTab === "vendor"
                                      ? "delete-vendor-enquiry"
                                      : "delete-enquiry",
                                  title:
                                    activeTab === "vendor"
                                      ? "Delete Vendor Enquiry"
                                      : "Delete Enquiry",
                                  data: {
                                    id: item.id,
                                    name: item.name,
                                    deleteFunction:
                                      activeTab === "vendor"
                                        ? VendorDeleteEnquiry
                                        : DeleteEnquiry,
                                    refreshData: fetchRoles,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnquiryList;